module.exports = __webpack_public_path__ + "img/unhcr_logo_white.8650eb40.svg";